import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { EnviormentConfig, IConfigObj, MylistService, OfferDetailService, OfferDetailsData, ProductUtilService, UserInfoService, UtilService } from 'abs-ngx-library/src/lib/core';

// jQuery declaration
declare let $: any;

@Component({
  selector: 'ndc-offer-detail-al-v1',
  templateUrl: './ndc-offer-detail-al-v1.component.html',
  styleUrls: ['./ndc-offer-detail-al-v1.component.scss']
})
export class NdcOfferDetailAlV1Component implements OnInit {

  @Input() offer;
  @Input() TriggerElement;
  @Input() configObj: IConfigObj;
  @Input() myListItems: any = [];
  public showSpinner:boolean = false;
  public offerDisclaimerExFrgPath:string;
  private config = EnviormentConfig;
  public currentEnv: string = '';
  public offerDetailsPznData: any;
  public dateString: string = '';
  public showAccordion: boolean = false;
  public isDisclaimerLoaded: boolean = false;

  constructor(private _offerDetailService: OfferDetailService,
              private _userInfoService: UserInfoService,
              private _utilService: UtilService,
              private _productUtilService: ProductUtilService,
              private myListService: MylistService,
              private elementRef: ElementRef
              ) { }

  ngOnInit(): void {
    if (this.offer) {
      this.showSpinner = true;
      this.offerDisclaimerExFrgPath = this.config.offerDisclaimerPath;
      if (this.offer.myListItems && this.offer.myListItems.length) {
        this.myListItems = [...[], ...this.offer.myListItems];
      }
      if (this.offer && this.offer.isWeeklyAdPzn) {
          this._offerDetailService.getOfferDetailsDataPzn(this.offer.offerId, this.offer.storeId, this.offer.includeUpc, this.offer.source).subscribe(data => {
              if (data) {
                this.offerDetailsPznData = data;
                this.dateString = this.createDateString();
              }
              this.showSpinner = false;
          })
          return
      }
    }
  }

  createDateString() {
    const startDate = new Date(Number(this.offerDetailsPznData.startDate));
    const endDate = new Date(Number(this.offerDetailsPznData.endDate));
    const numeric: any = {month: 'numeric', day: 'numeric'};
    return `${startDate.toLocaleDateString('en-US', numeric)} - ${endDate.toLocaleDateString('en-US', numeric)}`;
  }

  public toggleAccordion(){
    if (!this.isDisclaimerLoaded){
        this._offerDetailService.getOfferDisclaimerTemplate(this.offerDisclaimerExFrgPath, this.configObj).subscribe(response => {
            if (response) {
                $('.offer-terms-condition-pzn .cms-offer-terms-conditions').append(response);
                this.showAccordion = true;
                this.isDisclaimerLoaded = true;
            }
        });
    } else{
        this.showAccordion = !this.showAccordion;
    }
  }

  addToList() {
    if (this._utilService.isTokenActive() && this._userInfoService.isAuthorized()) {
        const payload = {
            "items": [{
                clipType: 'L',
                itemId: this.offerDetailsPznData.offerId,
                itemType: this.offerDetailsPznData.offerPgm,
                wsSource: this.offerDetailsPznData.source,
            }]
        };
        this._offerDetailService.addToList(payload).subscribe(response => {
            if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                this.offerDetailsPznData.status = 'C';
                this.offerDetailsPznData.deleted = false;
                this.myListService.getMyList(window['AB'].userInfo.branchId, true).subscribe((mylist: any) => {

                  // console.warn('weekly-ad mylist: ' + JSON.stringify(mylist));
                  if (mylist && mylist.shoppingLists && mylist.shoppingLists[0] && mylist.shoppingLists[0].items) {
                      this.myListItems = [...[], ...mylist.shoppingLists[0].items];
                  }
  
                });
                this._offerDetailService.couponUpdated.next({...this.offerDetailsPznData, status: 'C', deleted: false});
            }
        });
        this.trackAnalyticsClicks('add-to-list');
    } else {
        const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
        const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
        const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('add-to-list', navPath) || '';
        window.location.assign(navPath + `${analyticsIcmpid}`);
        return;
    }
  }

  removeFromList() {
    if (this._utilService.isTokenActive() && this._userInfoService.isAuthorized()) {
      const items = [];
      if (this.myListItems != null) {
        this.myListItems.forEach(element => {
            if (element.referenceId == this.offerDetailsPznData.offerId) {
                items.push({ id: element.id});
            }
        });
      }
      const payload = {
        "items": items
      };
      this._offerDetailService.removeFromList(payload).subscribe(response => {
          if (response && response['items'] && response['items'][0]) {
              this.offerDetailsPznData.deleted = true;
              this._offerDetailService.couponUpdated.next({...this.offerDetailsPznData, status: 'C', deleted: true});
          }
      });
      this.trackAnalyticsClicks('remove-from-list');
    } else {
        const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
        window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
        return;
    }
  }

  trackAnalyticsClicks(source?: string) {
    if (window['AB'] && window['AB']['DATALAYER']) {
      const sectionTitle = window['AB']['DATALAYER'].sanitizeAnalyticsText(window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this.elementRef.nativeElement));
      window['AB']['DATALAYER'].setLinkClickEvents(
        `weekly-ad${source === 'eligible-items' || source === 'offer-details' 
          ? `:${sectionTitle}` 
          : ''}${source ? `|${source}` : ''}`, false , `${source === 'add-to-list' ? `weekly-ad:${sectionTitle}` : ''}`
      );
    }
  }

}
